import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivate, Data } from '@angular/router';

import { StatsigService } from '@app/services/statsig.service';
import { Session } from '@services/session';

interface IFacilityMonitoringAccessGuard {
  flag: string;
  redirectTo?: string;
}

@Injectable()
export class FacilityMonitoringAccessGuard implements CanActivate {
  constructor(private router: Router, private session: Session, private statsigService: StatsigService) { }

  public canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    const data: Data = route.data;
    const config: IFacilityMonitoringAccessGuard = data.facilityMonitoringAccessGuard;
    const redirectTo: string = config.redirectTo || '/';

    if (this.statsigService.evaluateGate(config.flag)) {
      if (this.session.isAdmin()) {
        return true;
      } else {
        return this.router.navigate([redirectTo]);
      }
    } else {
      return false;
    }
  }
}
